import React from "react";

function PaymentLogos({ title, logos, style }) {
  return (
    <div className="holder-payment-cards flex">
      {title && (
        <p className="font-montserrat font-normal text-gray">{title}</p>
      )}
      <ul className="holder-payment flex mt-2">
        {logos.map((item) => {
          return (
            <li className="card-list">
              <img src={item} class={style} />
            </li>
          );
        })}
      </ul>
    </div>
  );
}

export default PaymentLogos;
